import React from 'react';
import { Box, Move, Stagger } from '@razorpay/blade/components';

import { LeaveCalendarYear } from './components/LeaveCalendarYear';
import { LeavePolicies } from './components/LeavePolicies';
import { LeaveTypesTable } from './components/LeaveTypesTable/LeaveTypesTable';
import { OrgHolidaysTable } from './components/OrgHolidaysTable/OrgHolidaysTable';

export const LeavesAndHolidaysTab = () => {
  return (
    <Stagger
      motionTriggers={['mount']}
      delay="2xquick"
      display="flex"
      flexDirection="column"
      gap="spacing.8">
      <Move>
        <Box>
          <LeaveCalendarYear />
        </Box>
      </Move>

      <Move>
        <Box>
          <OrgHolidaysTable />
        </Box>
      </Move>

      <Move>
        <Box>
          <LeaveTypesTable />
        </Box>
      </Move>

      <Move>
        <Box>
          <LeavePolicies />
        </Box>
      </Move>
    </Stagger>
  );
};
